export default __webpack_public_path__ + "14c05ff3.png";